import React from 'react';



export default function ContactInfoFields({ type, formData, errors, handleInputChange }) {
  const prefix = type === 'sender' ? 'sender' : 'receiver';

  return (
    <>
      <div className="col-span-1 sm:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Nom complet *
        </label>
        <input
          type="text"
          value={formData?.[`${prefix}Name`]}
          onChange={handleInputChange(`${prefix}Name`)}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base min-h-[44px]"
          placeholder="Nom complet"
        />
        {errors?.[`${prefix}Name`] && (
          <p className="text-xs sm:text-sm text-red-600 mt-1">{errors?.[`${prefix}Name`]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Téléphone *
        </label>
        <input
          type="tel"
          value={formData?.[`${prefix}Phone`]}
          onChange={handleInputChange(`${prefix}Phone`)}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base min-h-[44px]"
          placeholder="+33 6 12 34 56 78"
        />
        {errors?.[`${prefix}Phone`] && (
          <p className="text-xs sm:text-sm text-red-600 mt-1">{errors?.[`${prefix}Phone`]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Ville *
        </label>
        <input
          type="text"
          value={formData?.[`${prefix}City`]}
          onChange={handleInputChange(`${prefix}City`)}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base min-h-[44px]"
          placeholder="Ville"
        />
        {errors?.[`${prefix}City`] && (
          <p className="text-xs sm:text-sm text-red-600 mt-1">{errors?.[`${prefix}City`]}</p>
        )}
      </div>

      <div className="col-span-1 sm:col-span-2">
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Adresse *
        </label>
        <textarea
          value={formData?.[`${prefix}Address`]}
          onChange={handleInputChange(`${prefix}Address`)}
          rows={3}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base resize-none"
          placeholder="Adresse complète"
        />
        {errors?.[`${prefix}Address`] && (
          <p className="text-xs sm:text-sm text-red-600 mt-1">{errors?.[`${prefix}Address`]}</p>
        )}
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Code postal
        </label>
        <input
          type="text"
          value={formData?.[`${prefix}PostalCode`]}
          onChange={handleInputChange(`${prefix}PostalCode`)}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base min-h-[44px]"
          placeholder="Code postal"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1.5">
          Pays *
        </label>
        <input
          type="text"
          value={formData?.[`${prefix}Country`]}
          onChange={handleInputChange(`${prefix}Country`)}
          className="w-full px-3 sm:px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent text-sm sm:text-base min-h-[44px]"
          placeholder="Pays"
        />
        {errors?.[`${prefix}Country`] && (
          <p className="text-xs sm:text-sm text-red-600 mt-1">{errors?.[`${prefix}Country`]}</p>
        )}
      </div>
    </>
  );
}